import { render, staticRenderFns } from "./ConsentBox.vue?vue&type=template&id=059f3966&scoped=true&"
import script from "./ConsentBox.vue?vue&type=script&lang=ts&"
export * from "./ConsentBox.vue?vue&type=script&lang=ts&"
import style0 from "./ConsentBox.vue?vue&type=style&index=0&id=059f3966&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059f3966",
  null
  
)

export default component.exports